import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import Carousel from 'react-multi-carousel'
import { HeartIcon } from '../../Images/svgs'

function MapCard({ project, index }) {

    const { images } = project

    return (
        <div className="flex flex-col p-2 bg-white rounded-lg border border-solid border-zinc-300 max-w-[269px]">
            <div className=" space-y-4">
                <Carousel
                    additionalTransfrom={0}
                    sw
                    arrows={false}
                    autoPlaySpeed={3000}
                    centerMode={false}
                    className="mb-3"
                    containerClass="container "
                    dotListClass=""
                    draggable={false}
                    focusOnSelect={false}
                    infinite={false}
                    itemClass=""
                    keyBoardControl
                    minimumTouchDrag={80}
                    pauseOnHover
                    renderArrowsWhenDisabled={false}
                    renderButtonGroupOutside={false}
                    renderDotsOutside={false}
                    responsive={{
                        desktop: {
                            breakpoint: {
                                max: 3000,
                                min: 1024
                            },
                            items: 1
                        },
                        mobile: {
                            breakpoint: {
                                max: 464,
                                min: 0
                            },
                            items: 1
                        },
                        tablet: {
                            breakpoint: {
                                max: 1024,
                                min: 464
                            },
                            items: 1
                        }
                    }}
                    rewind={false}
                    rewindWithAnimation={false}
                    rtl={true}
                    shouldResetAutoplay
                    showDots
                    sliderClass=""
                    slidesToSlide={1}
                    swipeable={false}
                >
                    {Object.entries(images)
                        .filter(([key, value]) => key === 'image')
                        .map(([key, imageUrl]) => (
                            <div key={key} className="flex overflow-hidden relative flex-col justify-between self-stretch px-3 pt-3 pb-12 text-sm font-medium tracking-normal leading-3 text-center text-emerald-900 uppercase whitespace-nowrap rounded-md aspect-[1.26] ">
                                <img
                                    src={imageUrl}
                                    className="object-cover absolute inset-0 size-full"
                                    alt={`Image for ${key}`}
                                />
                                <div className="flex relative gap-5 justify-between">
                                    <div className="justify-center px-2.5 py-1 my-auto bg-emerald-100 rounded-xl border-emerald-900 border-solid border-[0.5px]">
                                        بيوت فقراء
                                    </div>
                                    <HeartIcon fill={'red'} className="w-6 aspect-square" />
                                </div>
                            </div>
                        ))}

                </Carousel>
            </div>
            <div className="flex flex-col p-2 mt-1">
                <div className="text-xl font-bold text-right text-zinc-900">
                    الشابة &quot;أمل&quot; قصة نجاح لم تكتمل إلا بعطائكم
                </div>
                <div className="self-start mt-3 text-sm text-right whitespace-nowrap text-stone-900">
                    آخر تبرع قبل ساعتين
                </div>
                <div className="flex flex-col justify-center items-end pl-16 mt-2 bg-gray-200 rounded">
                    <div className="h-2 rounded w-[138px]" />
                </div>
                <div className="flex gap-5 justify-between mt-3 text-right text-stone-900">
                    <div className="text-sm">$100,000 دولار</div>
                    <div className="text-base font-bold">66,200$ دولار </div>
                </div>
            </div>
            <div className="flex gap-2 justify-between mt-1">
                <div className="flex justify-center items-center px-3.5 py-3 bg-white rounded-lg border border-solid shadow-sm aspect-[1.11] border-[color:var(--Gray-300,#D0D5DD)]">
                    <LazyLoadImage
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/d0a8ce30de9e71c6386b252082119e78241b5192456497ff0d1d99ae2dcf6001?"
                        className="aspect-[1.05] w-[21px]"
                    />
                </div>
                <div className="flex grow gap-5 justify-between p-1 whitespace-nowrap bg-white rounded-lg border border-solid border-[color:var(--Gray-300,#D0D5DD)]">
                    <div className="justify-center px-3.5 py-2 text-sm font-semibold leading-5 text-white bg-blue-600 rounded-lg border border-blue-500 border-solid shadow-sm aspect-[1.39]">
                        تبرع
                    </div>
                    <div className="my-auto text-base leading-6 text-right text-gray-500">
                        القيمة
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MapCard